export enum SortDirection {
  None = 'None',
  ToUp = 'ToUp',
  ToDown = 'ToDown'
}
